
// Companies
export const GET_COMPANIES = "/company/companies";
export const ADD_NEW_COMPANIES = "/company/companies";
export const UPDATE_COMPANIES = "/company/companies";
export const DELETE_COMPANIES = "/company/companies";
export const ADD_COMPANY_SIGNATURE = "/company/signatures";

// Company Establishments
export const GET_ESTABLISHMENTS = "/company/establishment";
export const ADD_NEW_ESTABLISHMENT = "/company/establishment";
export const UPDATE_ESTABLISHMENT = "/company/establishment";
export const DELETE_ESTABLISHMENT = "/company/establishment";

// Company Emission Points
export const GET_EMISSION_POINTS = "/company/emissionPoint";
export const ADD_NEW_EMISSION_POINT = "/company/emissionPoint";
export const UPDATE_EMISSION_POINT = "/company/emissionPoint";
export const DELETE_EMISSION_POINT = "/company/emissionPoint";
